import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Column, Thumbnail, Padding } from '../../../..'
import { colors, Routes } from '../../../../../constants'
import Button from '../../../../Button'

const Wrapper = styled.div`
    display: flex;
    height: 120px;
`

const TopAligned = styled(Padding)`
    display: flex;
`

const LeftInnerColumn = styled(Column)`
    display: flex;
    flex-direction: column;
`

const ChannelName = styled.div`
    color: ${colors.bluedark};
    font-weight: bold;
`

const UpdatedAt = styled.span`
    color: ${colors.grey};
    font-size: 14px;
`

const DevicesLength = styled.div`
    color: ${colors.grey};
`

const MediaLength = styled.div`
    flex-grow: 2;
    display: flex;
    align-items: flex-end;
`

const RightColumn = styled(Column)`
    border-left: 1px solid ${colors.greylight};
`

const RightColumnInnerWrapper = styled(Padding)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
`

const MediaThumbnail = styled.div`
    height: 80px;
`

const RestOfMedia = styled.div`
    color: ${colors.grey};
    font-size: 12px;
`

const DeleteButton = styled(Button)`
  border-radius 0 5px 5px 0;
`


const Channel = ({ devices, name, totalLayers, id, totalMedia, mediaIDToPlay, onRemoveChannel, updatedAt, estate }) => {
    const { t } = useTranslation()

    const url = [Routes.CONTENT, `s=${name}`].join('?')
    const channelLink = Routes.buildRoute(url, { estate, channel: id })

    return (
        <Wrapper>
            <Column width="70%">
                <TopAligned fullHeight>
                    <LeftInnerColumn>
                        <ChannelName>
                            <Link to={channelLink}>
                                {name}
                            </Link>
                        </ChannelName>
                        <DevicesLength>{t('channel-number-devices', { count: devices })}</DevicesLength>
                        <MediaLength>
                            {!totalLayers && !totalMedia && t('channel-number-media-layers-empty')}
                            {!totalLayers && !!totalMedia && t('channel-number-media', { count: totalMedia })}
                            {!totalMedia && !!totalLayers && t('channel-number-layers', { count: totalLayers })}
                            {!!totalMedia &&
                                !!totalLayers &&
                                t('channel-number-media-layers', {
                                    media: totalMedia,
                                    layers: totalLayers,
                                })}
                        </MediaLength>
                    </LeftInnerColumn>
                    <Column right>
                        <UpdatedAt>{t('channel-updated-at', { when: moment(updatedAt).fromNow() })}</UpdatedAt>
                    </Column>
                </TopAligned>
            </Column>
            <RightColumn width="30%">
                <RightColumnInnerWrapper>
                    <MediaThumbnail>
                        <Thumbnail mediaId={mediaIDToPlay} withPlayer />
                    </MediaThumbnail>
                    <RestOfMedia>{totalMedia > 1 && t('channel-info-rest-of-media', { count: totalMedia - 1 })}</RestOfMedia>
                </RightColumnInnerWrapper>
            </RightColumn>
            {onRemoveChannel && (
                <DeleteButton theme="danger" radius="5" onClick={onRemoveChannel}>
                    <FontAwesomeIcon icon="trash-alt" />
                </DeleteButton>
            )}
        </Wrapper>
    )
}

Channel.propTypes = {
    name: PropTypes.string,
    id: PropTypes.number,
    devices: PropTypes.number,
    totalLayers: PropTypes.number,
    totalMedia: PropTypes.number,
    mediaIDToPlay: PropTypes.number,
    onRemoveChannel: PropTypes.func,
    updatedAt: PropTypes.string,
}

Channel.defaultProps = {
    name: '',
    id: null,
    devices: 0,
    totalLayers: 0,
    totalMedia: 0,
    mediaIDToPlay: null,
    onRemoveChannel: null,
    updatedAt: null,
}

export default withRouter(Channel)
